module.exports = "<p [ngClass]=\"{'alert-danger':currentStyle === 'error',\n'alert-success': currentStyle === 'success',\n'alert': currentStyle !== '',\n'alert-info':currentStyle === 'info'}\" *ngIf=\"show()\">{{message}}</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/messages/message.component.html
// module id = ./src/app/components/messages/message.component.html
// module chunks = main